export default __webpack_public_path__ + "static/media/ig-post-6.56468787.jpeg";